import { render, staticRenderFns } from "./CButton.vue?vue&type=template&id=7efbb704&scoped=true&lang=pug&"
import script from "./CButton.vue?vue&type=script&lang=ts&"
export * from "./CButton.vue?vue&type=script&lang=ts&"
import style0 from "./CButton.vue?vue&type=style&index=0&id=7efbb704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efbb704",
  null
  
)

export default component.exports